import {
    takeLatest,
    put,
    select,
    take,
    takeEvery
} from 'redux-saga/effects';
import { push } from 'react-router-redux';

import { takeFirst } from './helperSaga';
import { ACTIONS } from '../actions/actionTypes';
import { ACTIONS as AUTH_ACTIONS } from '../containers/Auth/auth.actionTypes';

// APP_STATE SAGA, EVERYTHING THAT NEEDS TO BE HANDLED IN THE APP STARTUP
export function * S_APP_STARTED () {
    yield takeEvery(ACTIONS.S_APP_STARTED, function * (action) {
        const Authenticated = yield select(state => state.auth.isAuthenticated);
        if (Authenticated) {
            // CHECK REDUCER TO SEE IF DATA IS PRESENT
            yield put({type: ACTIONS.S_APP_REDIRECT, payload: true});
        }
    });
}

// IF USER PRESENT REDIRECT HIM TO HIS PRIVATE ROUTES
export function * S_APP_REDIRECT () {
    yield takeLatest(AUTH_ACTIONS.AUTH_LOGIN_USER_SUCCESS, function * (action) {
        let userLocal = localStorage.getItem('user');
        userLocal = JSON.parse(userLocal);
        if (userLocal !== null) {
            yield put({type: ACTIONS.USER_SET_DATA, payload: userLocal});
            yield put({type: ACTIONS.S_APP_REDIRECT, payload: true});
        } else {
            const AuthData = yield select(state => state.auth.user);
            const UserData = yield select(state => state.user.data);
            yield put({type: ACTIONS.USER_SET_DATA, payload: AuthData});
            yield put({type: ACTIONS.S_APP_REDIRECT, payload: true});
        }
    });

    yield takeLatest(AUTH_ACTIONS.AUTH_SIGNUP_USER_SUCCESS, function * (action) {
        let userLocal = localStorage.getItem('user');
        userLocal = JSON.parse(userLocal);
        if (userLocal !== null) {
            yield put({type: ACTIONS.USER_SET_DATA, payload: userLocal});
            yield put({type: ACTIONS.S_APP_REDIRECT, payload: true});
        } else {
            const AuthData = yield select(state => state.auth.user);
            const UserData = yield select(state => state.user.data);
            yield put({type: ACTIONS.USER_SET_DATA, payload: AuthData});
            if (!AuthData.city || !UserData.city) {
                yield put({type: ACTIONS.S_APP_REDIRECT, payload: true});
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/sagas/appSaga.js